import React from 'react'

export default function ProjectIcon() {
    return (
        <svg
            className='opacity-30'
            xmlns="http://www.w3.org/2000/svg"
          
            enableBackground="new 0 0 512 512"
            viewBox="0 0 64 64"
        >
            <g xmlns="http://www.w3.org/2000/svg">
                <path
                    fill="#a97c50"
                    d="M56 15v42a4 4 0 01-4 4H18a4 4 0 01-2.4-.8 3.774 3.774 0 01-.73-.71A4.026 4.026 0 0114 57V15a4 4 0 014-4h34a4 4 0 014 4z"
                    data-original="#a97c50"
                ></path>
                <path 
                    fill="#e6e7e8"
                    d="M52 16v33h-6a2.006 2.006 0 00-2 2v6H19a1 1 0 01-1-1V16a1 1 0 011-1h32a1 1 0 011 1z"
                    data-original="#e6e7e8"
                ></path>
                <path 
                    fill="#d8d7da"
                    d="M38.83 43.51l-.71 3.54L36 49.17A2.016 2.016 0 0036 52a2 2 0 002.83 0l2.12-2.12 3.54-.71.7-.71L52 41.65v-11.3z"
                    data-original="#d8d7da"
                ></path>
                <path
                    fill="#8b5e3c"
                    d="M56 26.35l-4 3.998V41.65l4-4z"
                    data-original="#8b5e3c"
                ></path>
                <path 
                    fill="#d8d7da"
                    d="M27.68 52.47a9.8 9.8 0 01-1.09 2.62L28.02 57H19a1 1 0 01-1-1V37h2l.47 3.32a9.8 9.8 0 012.62 1.09l2.69-2.02 2.83 2.83-2.02 2.69a9.8 9.8 0 011.09 2.62L31 48v4z"
                    data-original="#d8d7da"
                ></path>
                <path
                    fill="#e6e7e8"
                    d="M60.16 23.84a3.986 3.986 0 00-2.82-1.18 3.825 3.825 0 00-1.34.24 3.924 3.924 0 00-1.49.94l-1.42 1.41L56 28.16l2.75 2.75 1.41-1.42a3.978 3.978 0 000-5.65z"
                    data-original="#e6e7e8"
                ></path>
                <path 
                    fill="#ffa733"
                    d="M56 28.16l-2.91-2.91L52 26.34v.01l-1.03 1.02L52 28.4l1.8 1.8 2.2 2.2.63.63 2.12-2.12z"
                    data-original="#ffa733"
                ></path>
                <path
                    fill="#d1d3d4"
                    d="M52 49l-8 8v-6a2.006 2.006 0 012-2z"
                    data-original="#d1d3d4"
                ></path>
                <path
                    fill="#e6e7e8"
                    d="M52 49v7a1 1 0 01-1 1h-7z"
                    data-original="#e6e7e8"
                ></path>
                <path
                    fill="#787680"
                    d="M38.95 47.88L36.83 50a2 2 0 01-3.41-1.42 1.983 1.983 0 01.58-1.41l2.12-2.12z"
                    data-original="#787680"
                ></path>
                <path
                    fill="#898890"
                    d="M43.19 46.46l-.7.71-3.54.71-2.83-2.83.71-3.54.71-.7 2.82 2.83h.01z"
                    data-original="#898890"
                ></path>
                <path
                    fill="#00ccb3"
                    d="M52 28.4l-1.03-1.03-13.43 13.44 2.82 2.83h.01L52 32l1.8-1.8z"
                    data-original="#00ccb3"
                ></path>
                <path
                    fill="#00b39d"
                    d="M56 32.4l-2.2-2.2L52 32 40.37 43.64l2.82 2.82L52 37.65l4-4 .63-.62z"
                    data-original="#00b39d"
                ></path>
                <path
                    fill="#ff5023"
                    d="M31.28 26.72A4 4 0 1128 25a4.009 4.009 0 013.28 1.72z"
                    data-original="#ff5023"
                ></path>
                <path fill="#ffa733" d="M24 16h22v3H24z" data-original="#ffa733"></path>
                <path
                    fill="#ff9811"
                    d="M44.64 11A4 4 0 0042 10h-3V7a4 4 0 10-8 0v3h-3a4.009 4.009 0 00-4 4v2h22v-2a3.984 3.984 0 00-1.36-3z"
                    data-original="#ff9811"
                ></path>
                <path
                    fill="#8b5e3c"
                    d="M28.61 57.78L27.39 59l-1.61 1.61L23.64 59l-.55-.41a8.141 8.141 0 01-.77.41 9.492 9.492 0 01-1.85.68L20.28 61H18a4 4 0 01-2.4-.8l-.07-.52c-.22-.06-.45-.12-.66-.19A4.026 4.026 0 0114 57V40.86a8.956 8.956 0 011.53-.54L16 37h2v19a1 1 0 001 1h9.02z"
                    data-original="#8b5e3c"
                ></path>
                <path 
                    fill="#ff9811"
                    d="M25.68 50.47a9.8 9.8 0 01-1.09 2.62l2.02 2.69L25.39 57l-1.61 1.61L21.64 57l-.55-.41a8.141 8.141 0 01-.77.41 9.492 9.492 0 01-1.85.68L18 61h-4l-.47-3.32a9.8 9.8 0 01-2.62-1.09l-2.69 2.02-2.83-2.83 2.02-2.69a9.8 9.8 0 01-1.09-2.62L3 50v-4l3.32-.47a9.8 9.8 0 011.09-2.62l-2.02-2.69 2.83-2.83 2.69 2.02a9.8 9.8 0 012.62-1.09L14 35h4l.47 3.32a9.8 9.8 0 012.62 1.09l2.69-2.02 2.83 2.83-2.02 2.69a9.8 9.8 0 011.09 2.62L29 46v4z"
                    data-original="#ff9811"
                ></path>
                <path
                    fill="#ffd422"
                    d="M18 43.41a5.083 5.083 0 00-4 0 5.011 5.011 0 000 9.18 5.083 5.083 0 004 0 5.011 5.011 0 000-9.18z"
                    data-original="#ffd422"
                ></path>
                <path fill="#cc7400" d="M34 6h2v2h-2z" data-original="#cc7400"></path>
                <g fill="#ee8700">
                    <path d="M15 38h2v2h-2z" data-original="#ee8700"></path>
                    <path
                        d="M8.636 40.636h2v2h-2z"
                        data-original="#ee8700"
                        transform="rotate(-45 9.63 41.641)"
                    ></path>
                    <path d="M6 47h2v2H6z" data-original="#ee8700"></path>
                    <path
                        d="M8.636 53.364h2v2h-2z"
                        data-original="#ee8700"
                        transform="rotate(-45 9.627 54.37)"
                    ></path>
                    <path d="M15 56h2v2h-2z" data-original="#ee8700"></path>
                    <path
                        d="M21.364 53.364h2v2h-2z"
                        data-original="#ee8700"
                        transform="rotate(-45 22.356 54.373)"
                    ></path>
                    <path d="M24 47h2v2h-2z" data-original="#ee8700"></path>
                    <path
                        d="M21.364 40.636h2v2h-2z"
                        data-original="#ee8700"
                        transform="rotate(-45 22.358 41.644)"
                    ></path>
                </g>
                <path
                    fill="#d80027"
                    d="M26.964 26.5h7.071v2h-7.071z"
                    data-original="#d80027"
                    transform="rotate(-45 30.497 27.507)"
                ></path>
                <path 
                    fill="#c6c5ca"
                    d="M35 26h2v2h-2zM39 26h4v2h-4zM35 30h6v2h-6z"
                    data-original="#c6c5ca"
                ></path>
            </g>
        </svg>
    )
}
